import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { Text, ProgressIndicator, Layout } from '@oneaudi/unified-web-components';
import SearchResultsList from '../SearchResultsList/SearchResultsList';
import { messages } from '../../../i18n/messages';
import mapContext from '../../../contexts/map-context';
import { Dealer } from '../../../models/dealer';
import { SearchResultsAmount } from './SearchResultsAmount';

type Props = {
  results: Dealer[] | null;
};

export const SearchResultsGroup = React.forwardRef<HTMLDivElement, Props>(({ results }, ref) => {
  const { isLoading } = mapContext.useMapState();
  const resultEmptyText = useI18n(messages.search_result_empty);

  if (!results) {
    return (
      <SearchResultsGroupContainer
        data-test-id="search-results-group"
        ref={ref}
        direction="column"
        margin={['24px', '28px', '24px', '28px']}
      />
    );
  }

  return isLoading ? (
    <LoaderContainer>
      <ProgressIndicator variant="bar" type="infinite" data-test-id="loader-component" />
    </LoaderContainer>
  ) : (
    <SearchResultsGroupContainer data-test-id="search-results-group" ref={ref} direction="column">
      {results && results.length === 0 ? (
        <SearchResultsEmptyContainer data-test-id="search-results-empty-container">
          <Text tag="span" variant={{ order: '1', style: 'normal', type: 'copy' }}>
            {resultEmptyText}
          </Text>
        </SearchResultsEmptyContainer>
      ) : (
        <>
          <SearchResultsAmountContainer>
            <SearchResultsAmount />
          </SearchResultsAmountContainer>
          <SearchResultsList results={results} />
        </>
      )}
    </SearchResultsGroupContainer>
  );
});

const SearchResultsEmptyContainer = styled.div`
  margin: 24px;
`;

const SearchResultsGroupContainer = styled(Layout)`
  position: relative;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  padding: 0 28px 24px 28px;

  &:hover {
    &::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
    visibility: hidden;
  }
`;

const LoaderContainer = styled.div`
  padding: 24px;
`;
const SearchResultsAmountContainer = styled.div`
  position: sticky;
  top: 0;
  background: #fff;
`;
